<!-- 測定結果のプレビュー画面 -->
<template>
  <div class="whole-wrap whole-wrap--heavy">
    <BurgerMenuComponentPC
      @back="goBack"
      @print="goPrint"
      :isWhiteBack="true"
      :isBack="true"
      :isPrint="true"
      :isTitle="$t('report.title')"
      />

    <div class="result-body">
      <div id="printArea" class="report" :class="!viewOFResult ? 'report--no-of' : ''">
        <!-- ヘッダー -->
        <div class="report-header">
          <div class="report-header-detail">
            <div class="header-left">
              <span class="header-left-blue">{{ $t('report.oral_function') }}</span>{{ $t('report.title_sub') }}
              <span class="header-left-slash">/</span>
              <span class="header-left-name" :class="subject_name===''?'ml-140':''">{{subject_name}} {{ $t('subject.honorific') }}</span>
            </div>
            <div class="header-right">
              <span>{{subjectId}}</span>
              <span class="ml-16">{{genderText}}</span>
              <span class="ml-16">{{age}}{{$t('subject.years_old')}}</span>
            </div>
          </div>
        </div>

        <!-- ライン -->
        <div class="report-line"></div>

        <!-- レポート本体(viewOFResultにより表示コンポーネントを切り替え) -->
        <MeasureResultBodyWithOf
          v-if="viewOFResult"
          :isAnalysisFlag="isAnalysisFlag"
          :measurements="measurements"
          :vocabPerSeconds="vocabPerSeconds"
          :vocabCounts="vocabCounts"
          :analysisVocabCounts="analysisVocabCounts"
          :graphPercent="graphPercent"
          :measurementType="measurementType"
          :ofResultFlag="ofResultFlag"
          :ofTotalFlag="ofTotalFlag"
          :taResultFlag="taResultFlag"
          :taResultScore="taResultScore"
          :answers="answers"
          :labels="labels"
          :inspectionTimeText="inspectionTime(endDateTime)"
        />
        <MeasureResultBodyWithoutOf
          v-else
          :isAnalysisFlag="isAnalysisFlag"
          :measurements="measurements"
          :vocabPerSeconds="vocabPerSeconds"
          :vocabCounts="vocabCounts"
          :analysisVocabCounts="analysisVocabCounts"
          :graphPercent="graphPercent"
          :measurementType="measurementType"
          :inspectionTimeText="inspectionTime(endDateTime)"
        />

      </div>
    </div>
  </div>
</template>

<script>
// import { ref, onMounted, onBeforeUnmount } from 'vue';
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { formatPDFTime } from './common/dateFormatter';
import Chart from 'chart.js/auto';
import BurgerMenuComponentPC from './BurgerMenuPc.vue';
import { findSubjectName } from './common/persistenceUtils';
import MeasureResultBodyWithOf from './MeasureResultBodyWithOf.vue';
import MeasureResultBodyWithoutOf from './MeasureResultBodyWithoutOf.vue';

export default {
  components: {
    BurgerMenuComponentPC,
    MeasureResultBodyWithOf,
    MeasureResultBodyWithoutOf,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();

    //-------------新ファイル部分--------------------
    // グラフパラメータの初期化
    const canvas = ref(null);
    const canvasCtx = ref(null);
    const vocabPerSeconds = ref({});
    const vocabCounts = ref({});
    const analysisVocabCounts = ref({});
    const graphPercent = ref({});

    // その他の変数の初期化
    // const measureCount = ref(0);
    const genderText = ref('');
    // const measurementTypeText = ref('');
    const subject_name = ref(''); //氏名
    const ofResultFlag = ref(false); //of-5に該当するかのフラグ：true(該当する):false(該当しない)
    const taResultScore = ref(null); // タの音声のスコア
    const taResultFlag = ref(false); //タの音声の音声がある場合、タのスコアを含む解析の実施:'true'(タの音声検査実施済み):'false'(タの音声実施がない場合)
    const ofTotalFlag =ref(false);
    const answers = ref([]); //of-5スコア保存用
    const viewOFResult = ref(false);
    const isAnalysisFlag = ref(false);

    //文言設定
    const labels = ref([]);

    // オブジェクトが{}か判定
    const isValidData = (data) => {
      return Reflect.ownKeys(data).length > 0;
    };
    // of-5が実施の判定
    const ResultOf5Data = store.getters['dataManagement/getResultOf5Data'];
    if (ResultOf5Data != null ) {
      if (isValidData(ResultOf5Data)) {
        viewOFResult.value = true;
      }
    }

    const report = store.getters['dataManagement/getResultReportData'];
    const reportOf = store.getters['dataManagement/getResultOf5Data'] || ['0', '0', '0', '0', '0'];

    // 音声解析のデータ格納
    const operatorId = report.operatorId ? report.operatorId: null;
    const subjectId = report.subject_id ? report.subject_id: null;
    const measurementType = report.measurement_type ? report.measurement_type: null;
    const analysisTypeFlag = report.analysisTypeFlag ? report.analysisTypeFlag : null;
    const gender = report.gender ? report.gender : null;
    const age = report.age ? report.age: null;
    const measurements = report.measurements ? report.measurements: [];
    const endDateTime = report.endDateTime ? report.endDateTime: null;
    const graphData = report.grap ? report.grap: [];

    subject_name.value = findSubjectName(subjectId);



    // 0f-5データ格納
    answers.value = Array.from({ length: 5 }, (_, i) => String(reportOf[`answers${i + 1}`]));
    // タの発音 vocabPerSecondを取り出し
    taResultScore.value = measurements.find(item => item.type === 'ta')?.vocabPerSecond || null;

    //明瞭度が実施の場合はisAnalysisFlagをtrueに
    if( analysisTypeFlag === '2'){isAnalysisFlag.value = true}

    // ストアからデータを取得して画面の初期化
    const fetchData = () => {
      // of-5回答文言データセット
      labels.value = [
      t('oral_frailty_of5.item_1'),
      t('oral_frailty_of5.item_2'),
      t('oral_frailty_of5.item_3'),
      t('oral_frailty_of5.item_4'),
      t('oral_frailty_of5.item_5a'),
      ]
    };

    // コンポーネントがマウントされたときにデータを取得
    onMounted(() => {
      window.scrollTo(0, 0);
      updateDisplayParams();
      const graphParams = setGraphParams();
      setChart(graphParams);

      //新バージョン
      fetchData();
      oralFrailtyJudgement();
    });

    //-------OF-5関係-------------
    // オーラルフレイル判定の処理
    const oralFrailtyJudgement = () =>{
      // OF-5判定:２以上ならtrue
      ofResultFlag.value = answers.value.filter(answer => answer === '1').length >= 2;

      // タの音声判定用の1～4問カウントアップ
      const count = ref(0);
      for (let i = 0; i < 4; i++) {
        if (answers.value[i] === '1') {
          count.value = ++count.value;
        }
      }

      // タの音声が6.0未満の場合：count＋1
      if (taResultScore.value < 6.0 ) { count.value++; }

      // OF-5の1～4問と6.0未満の内、2以上の場合はtrue
      if( count.value  >= 2 ) {
        taResultFlag.value = true;
      }

      // 最終的にオーラルフレイルに該当するか
      if(taResultFlag.value || ofResultFlag.value ) {
        ofTotalFlag.value = true;
      }
    }

    //-------グラフ関係-------------
    // グラフで使用する文言を取得
    function getGraphText(measureWord) {
      switch (measureWord) {
        case 'pa':
          return [t('report.lip_motion'), t('report.lip_motion_desc').replace(/<br\s*\/?>/gi, '')];
        case 'ta':
          return [t('report.anterior_tongue_motion'), t('report.anterior_tongue_motion_desc').replace(/<br\s*\/?>/gi, '')];
        case 'ka':
          return [t('report.posterior_tongue_motion'), t('report.posterior_tongue_motion_desc').replace(/<br\s*\/?>/gi, '')];
        default:
          return [];
      }
    }

    // 桁数に応じたフォントサイズを取得する関数
    function getFontSize(vocabPerSecond) {
      return vocabPerSecond >= 10 ? '22px' : '30px';
    }

    // 日時をフォーマットする関数
    const inspectionTime = (dateTime) => {
      return formatPDFTime(dateTime instanceof Date ? dateTime : new Date(Date.parse(dateTime)));
    };

    // グラフを描画する
    const setChart = (graphParams) => {
      measurements.forEach((measure) => {
        const canvasId = `graphCanvas-${measure.type}`;
        canvas.value = document.getElementById(canvasId);
        canvasCtx.value = canvas.value.getContext('2d');
        console.log(measure.status);
        if (measure.audioId) {
          const data = getChartData(graphParams[measure.type],measure.measurementType);

          // 不要なlabel配列を全て空文字''に設定
          if (data && Array.isArray(data.labels)) {
            data.labels = data.labels.map(() => '');
          }
          const options = getChartOptions(measure.measurementType);

          // const dpi = window.devicePixelRatio || 1;
          // canvas.value.style.width = canvas.value.width + 'px';
          // canvas.value.style.height = canvas.value.height + 'px';
          // canvas.value.width = canvas.value.width * dpi;
          // canvas.value.height = canvas.value.height * dpi;
          // // canvas.value.width = 157 * dpi;
          // // canvas.value.height = 106 * dpi;

          // canvasCtx.value.scale(dpi, dpi);

          // Chartオブジェクトを生成
          const lineChart = new Chart(canvasCtx.value, {
            type: 'line',
            data: data,
            options: options,
          });
          console.log('lineChart',lineChart);
          lineChart.update();
        }
      });
    };

    // 表示用のパラメータを更新する
    const updateDisplayParams = () => {
      // measureCount.value = parseInt(measurementType === '1' ? '5' : '10');
      genderText.value = gender === 1 ? t('subject.sex_male') : gender === 2 ? t('subject.sex_female') : gender === 3 ? t('subject.sex_other') : '';
      // measurementTypeText.value = measurementType === '1' ? '5' : '10';
    };

    // グラフ描画用のパラメータを設定する
    const setGraphParams = () => {
      const graphParams = {};

      graphData.forEach((item) => {
        const type = item.type || '';
        vocabPerSeconds.value[type] = item.vocabPerSecond !== null ? Number(item.vocabPerSecond).toFixed(1) : 0;
        vocabCounts.value[type] = item.vocabCount !==null ? item.vocabCount: null;
        analysisVocabCounts.value[type] = item.vocabAnalysisCount !==null ? item.vocabAnalysisCount: null;
        if (vocabCounts.value[type] !== null){
          graphPercent.value[type] =  Math.round((item.vocabAnalysisCount / item.vocabCount) * 100);
        }else{
          graphPercent.value[type] = 0;
        }


        if (!graphParams[type]) {
          graphParams[type] = {
            times: [],
            vocabRatesPerSecond: [],
            dtwRatesPerSecond: [],
            analysisTypeFlag: 0,
            measureWord: type,
          };
        }
        graphParams[type].times = item.vocabCountSecond || [];
        graphParams[type].vocabRatesPerSecond = item.vocabCountSecond || [];
        graphParams[type].dtwRatesPerSecond = item.vocabAnalysisCountSecond || [];
        graphParams[type].analysisType = item.duringAnalysisType !==null ? Number(item.duringAnalysisType): 1;

        // 一つでも明瞭さ解析を実施の場合はisAnalysisFlagをtrueへ
        if(graphParams[type].analysisType == 2){
          isAnalysisFlag.value = true
        }
        // console.log('isAnalysisFlag',isAnalysisFlag.value);
        // console.log('graphParams[type].analysisType',graphParams[type].analysisType);
      });
      return graphParams;
    };

    // チャートデータの取得
    function getChartData(graphParam, measurementType) {
      const { times, vocabRatesPerSecond, dtwRatesPerSecond, measureWord } = graphParam;

      const measurementTypeFlag = measurementType;

      const [mainColor, subColor] = getGraphColor(measureWord);
      const [mainColor_dtw, subColor_dtw] = getGraphColor('dtw');

      // 残す要素数を決定5秒か10秒かを判定
      let maxIndex = measurementTypeFlag == 1 ? 5 : 10;

      // 配列の不要な部分をnullにする関数
      function filterArray(arr, maxIndex) {
        return arr.map((val, index) => (index <= maxIndex ? val : null));
      }

      if (graphParam.analysisType == 2) {
        // 不要部分をnullに
        const vocabRatesPerSeconds = filterArray(vocabRatesPerSecond, maxIndex);
        const dtwRatesPerSeconds = filterArray(dtwRatesPerSecond, maxIndex);

        // 発音回数グラフのデータを取得
        const pronunciationDataset = {
          data: vocabRatesPerSeconds,
          segment: {
            borderColor: mainColor,
          },
          borderWidth: 3,
          pointRadius: 3,
          pointBorderWidth: 1.5,
          pointBackgroundColor: mainColor,
          pointBorderColor: subColor,
          clip: {top:0, right:10, bottom:0, left:0},
        };
        const dtwDataset = {
          data: dtwRatesPerSeconds,
          segment: {
            borderColor: mainColor_dtw,
          },
          borderWidth: 2,
          pointRadius: 3,
          pointBorderWidth: 1.5,
          pointBackgroundColor: (context) => {
            return vocabRatesPerSecond[context.index] == dtwRatesPerSecond[context.index] ? mainColor : mainColor_dtw;
          },
          pointBorderColor: subColor_dtw,
          clip: {top:0, right:10, bottom:0, left:0},
        };

        return { labels: times, datasets: [dtwDataset, pronunciationDataset] };

      } else {
        // 不要部分をnullに
        const vocabRatesPerSeconds = filterArray(vocabRatesPerSecond, maxIndex);

        // 発音回数グラフのデータを取得
        const pronunciationDataset = {
          data: vocabRatesPerSeconds,
          segment: {
            borderColor: mainColor,
          },
          borderWidth: 2,
          pointRadius: 3,
          pointBorderWidth: 1,
          pointBackgroundColor: mainColor,
          pointBorderColor: subColor,
          clip: {top:0, right:10, bottom:0, left:0},
        };

        return { labels: times, datasets: [pronunciationDataset] };

      }
    }

    // グラフで使用する色を取得
    function getGraphColor(measureWord) {
      // #e77f8f
      switch (measureWord) {
        case 'pa':
          return ['#d85368', '#ffffff']; // 赤
        case 'ta':
          return ['#49aa7d', '#ffffff']; // 緑
        case 'ka':
          return ['#208ffd', '#ffffff']; // 青
        case 'dtw':
          return ['#002850', '#ffffff']; // 明瞭度
        default:
          return ['#002850', '#ffffff']; // デフォルト: 黒
      }
    }

    // チャートオプションの取得
    function getChartOptions(measurementTypes) {
      const padding = {
        top: canvas.value.offsetWidth * 0.035,
        left: canvas.value.offsetWidth * 0.07,
        right: canvas.value.offsetWidth * 0.05,
        bottom: canvas.value.offsetWidth * 0.07,
      };

      const baseConfig = {
        animation: false,
        scales: {
          x: { min: 0, max: 10.2, display: false },
          y: { min: 0, max: 9.2, display: false },
        },
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
        layout: { padding },
        devicePixelRatio: 4
      };

      if (measurementTypes === '1') {
        baseConfig.scales.x = { min: 0, max: 5.2, display: false };
      }

      return baseConfig;
    }


    //-------他処理関係-------------
    // 戻る処理
    const goBack = () => {
      router.back();
    };

    // 刷処理
    const goPrint = () => {
      // 印刷を実行
      window.print();
    };

    // 次の測定へ進む処理
    const nextMeasure = async () => {
      try {
        // 被検査者情報をクリアしてから、被検査者情報ページに遷移
        await store.dispatch('dataManagement/clearSubject');
        router.push({
          name: 'subjectsRegist',
          params: { operator_id: operatorId },
        });
      } catch (error) {
        // エラーが発生した場合、コンソールにエラーメッセージを表示
        console.error('次の測定への遷移に失敗しました:', error);
      }
    };

    return {
      analysisTypeFlag,
      taResultScore,
      taResultFlag,
      ofResultFlag,
      ofTotalFlag,
      graphPercent,
      isAnalysisFlag,
      answers,
      labels,
      operatorId,
      subject_name,
      subjectId,
      measurementType,
      gender,
      age,
      measurements,
      endDateTime,
      genderText,
      inspectionTime,
      vocabPerSeconds,
      vocabCounts,
      analysisVocabCounts,
      getGraphText,
      getFontSize,
      nextMeasure,
      goBack,
      goPrint,
      viewOFResult,
      // measurementTypeText,
    };
  },
};
</script>

<style lang="scss" scoped>
input[type="checkbox"] {
  display: inline-block;
}

// OF-5ボックス無しの場合のみ、用紙を絶対配置の基準にする。
// MeasureResultBodyWithoutOf.vue のフッターがこれを基準に下端へ張り付く。
// (印刷時は #printArea が position:absolute になるため、そちらが基準になる)
.report.report--no-of {
  position: relative;
}
</style>